/** Path for in-app and App Store Connect Privacy Policy URL */
export const PRIVACY_POLICY_PATH = '/privacy';

export function getPrivacyPolicyUrl(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${PRIVACY_POLICY_PATH}`;
  }
  return `https://skimbuster.net${PRIVACY_POLICY_PATH}`;
}

/** Optional “User Privacy Choices” link (e.g. Apple App Privacy). Same page anchor. */
export const USER_PRIVACY_CHOICES_HASH = '#privacy-choices';

export function getUserPrivacyChoicesUrl(): string {
  return `${getPrivacyPolicyUrl()}${USER_PRIVACY_CHOICES_HASH}`;
}
